<!-- Footer - Figma node 25769:268040 -->
<footer
  class="hidden md:flex h-[88px] w-full shrink-0 items-center justify-between bg-white px-[132px] py-5 drop-shadow-[0px_4px_10px_rgba(0,0,0,0.1)]"
>
  <svg
    class="block h-6 w-[69px]"
    width="69"
    height="24"
    viewBox="0 0 69 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="IVY"
  >
    <path d="M6.20154 24H0V0H6.20154V24Z" fill="black" />
    <path
      d="M25.1055 17.8392L33.3004 0H39.7677L28.1177 24H21.8276L10.2218 0H16.9106L25.1055 17.8392Z"
      fill="black"
    />
    <path
      d="M51.8129 13.9126L40.8716 0H48.0476L55.0908 9.51199L62.134 0H69L57.9258 13.9126V24H51.8129V13.9126Z"
      fill="black"
    />
  </svg>

  <div class="flex items-center gap-10 whitespace-nowrap text-base leading-normal">
    <a
      class="text-black hover:underline"
      href="https://legal.stringhealth.ai/privacy-policy.html"
      target="_blank"
      rel="noopener"
      >Privacy Policy</a
    >
    <a
      class="text-black hover:underline"
      href="https://legal.stringhealth.ai/terms-of-use.html"
      target="_blank"
      rel="noopener"
      >Terms and Conditions</a
    >
    <button type="button" class="text-[#5D38F1] underline" (click)="logout()">
      Logout
    </button>
  </div>
</footer>
